export function client() {
    return {
        maxLength: 255,
    };
}

export function server() {
    return {
        limit_max: 255,
    };
}
